import type { AppNotice } from '../../types/notices/app-notice.type';

const typeOrder: Record<AppNotice['type'], number> = {
  update: 0,
  feature: 1,
  tip: 2,
};

/**
 * Selects one notice by category, newest date, then code-point ID ordering.
 * @param notices - Eligible notices registered by mounted producers.
 * @returns The highest-ranked notice, or undefined for an empty registry.
 */
export const selectAppNotice = (notices: AppNotice[]): AppNotice | undefined =>
  [...notices].sort((left, right) => {
    const priority = typeOrder[left.type] - typeOrder[right.type];
    if (priority !== 0) return priority;
    if (left.date !== right.date) return right.date - left.date;
    if (left.id === right.id) return 0;
    return left.id < right.id ? -1 : 1;
  })[0];
